export default __webpack_public_path__ + "static/media/results_3rd.26e3e49f.jpg";